import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./AuthContext";
import "./styles/tailwind.css";

import Home from "./pages/HomePage";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AddClient from "./pages/AddClient";
import Viewclients from "./pages/ViewClients";
import AlertsPage from "./pages/Alerts";

/** Helper: read admin from localStorage (doesn't rely on AuthContext) */
function isAdminUser() {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    return String(user?.Username || "").toLowerCase() === "admin";
  } catch {
    return false;
  }
}

/** Any logged-in user */
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" />;
};

/** Admin-only (username must be 'admin') */
const AdminRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" />;
  if (!isAdminUser()) return <Navigate to="/dashboard" />;
  return children;
};

const App = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />

          {/* Visible to any authenticated user */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          {/* Admin-only pages */}
          <Route
            path="/Viewclients"
            element={
              <ProtectedRoute>
                <AdminRoute>
                  <Viewclients />
                </AdminRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/AddClient"
            element={
              <ProtectedRoute>
                <AdminRoute>
                  <AddClient />
                </AdminRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/AlertsSettings"
            element={
              <ProtectedRoute>
                <AdminRoute>
                  <AlertsPage />
                </AdminRoute>
              </ProtectedRoute>
            }
          />

          {/* Catch-all:
             - If logged in & NOT admin → only allow dashboard
             - If not logged in → go to login
          */}
          <Route
            path="*"
            element={
              isAdminUser() ? <Navigate to="/dashboard" /> : (
                // If you want admins to see other pages, change target here
                <Navigate to="/dashboard" />
              )
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
};

export default App;
